import { getTagKind } from '../../helpers/get-tag-kind.js';
/** Label tags must not create operation groups, but undeclared tags still do. */
export const getNavigationTagNames = (document, names, tagsMap) => names?.filter((name) => getTagKind(document, tagsMap.get(name)?.tag) === 'nav') ?? [];
